import { NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./sse.service";
import * as i2 from "@angular/common/http";
var FeederService = /** @class */ (function () {
    function FeederService(_zone, _sseService, http) {
        this._zone = _zone;
        this._sseService = _sseService;
        this.http = http;
    }
    FeederService.prototype.getServerSentEvent = function (url) {
        var _this = this;
        return Observable.create(function (observer) {
            var es = _this._sseService.getEventSource(url);
            es.onmessage = function (event) {
                _this._zone.run(function () { return observer.next(event); });
            };
            es.onerror = function (error) {
                observer.error(error);
            };
        });
    };
    FeederService.prototype.getFeeders = function (body) {
        return this.http.post("getFeeders", body);
    };
    FeederService.prototype.getFeederData = function (body) {
        return this.http.post('getFeederData', body);
    };
    FeederService.prototype.getFeederTileData = function (body) {
        return this.http.post('getFeederTileData', body);
    };
    FeederService.prototype.getFeederAlertParamStatus = function (body) {
        return this.http.post('getFeederAlertParamStatus', body);
    };
    FeederService.prototype.getFeederManagerInfo = function (body) {
        return this.http.post('getFeederManagerInfo', body);
    };
    FeederService.prototype.getAlertFeederReport = function (body) {
        return this.http.post('getAlertFeederReport', body);
    };
    FeederService.prototype.getFeederPopupTileData = function (body) {
        return this.http.post('getFeederPopupTileData', body);
    };
    FeederService.prototype.getFeederAlertTileData = function (body) {
        return this.http.post('getFeederAlertTileData', body);
    };
    FeederService.prototype.addUpdateFeeder = function (body) {
        return this.http.post('addUpdateFeeder', body);
    };
    FeederService.prototype.getFeederDetails = function (body) {
        return this.http.post('getFeederDetails', body);
    };
    FeederService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeederService_Factory() { return new FeederService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.SseService), i0.ɵɵinject(i2.HttpClient)); }, token: FeederService, providedIn: "root" });
    return FeederService;
}());
export { FeederService };
